module.exports = __webpack_public_path__ + "img/img_partner.aae3e1a0.jpg";